import { AxiosResponse } from 'axios';
import qs from 'qs';
import {
  BlogPostResponseType,
  BlogPostType,
  QueryType,
  TrendingListResponseType,
} from 'src/types';

import { API } from './index';
import {
  createPostsfromRawPosts,
  createTrendingPostsFromRawPosts,
} from '@utils/common.utils';

async function fetchBlogList(query: QueryType) {
  const {
    start,
    limit,
    listTypeKey,
    searchTitle,
    language = 'en',
    listTypeValue,
  } = query;

  let url = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/blogs/fetchmany?`;
  let countUrl = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/blogs/count?`;

  const queryData: Record<string, any> = {};
  const countQueryData: Record<string, any> = {};

  if (listTypeKey) {
    queryData[`${listTypeKey}.slug`] = listTypeValue;
  }

  queryData['_start'] = start;
  queryData['_limit'] = limit;
  queryData['_sort'] = 'published_at:DESC';
  queryData['_locale'] = language.toLowerCase();
  queryData['_where'] = {
    1: {
      Language: language.toUpperCase(),
    },
  };

  countQueryData['_start'] = 0;
  countQueryData['_sort'] = 'published_at:DESC';
  countQueryData['_locale'] = language.toLowerCase();
  countQueryData['_where'] = {
    1: {
      Language: language.toUpperCase(),
    },
  };

  if (searchTitle) {
    queryData['Title_contains'] = searchTitle;
    countQueryData['Title_contains'] = searchTitle;
  }

  url += qs.stringify(queryData, { encode: false });

  countUrl += qs.stringify(countQueryData, { encode: false });

  const blogData: Promise<AxiosResponse<TrendingListResponseType[]>> =
    API.get(url);

  const [{ data }, { data: totalBlogCount }] = await Promise.all([
    blogData,
    API.get(countUrl),
  ]);

  return { blogList: createTrendingPostsFromRawPosts(data), totalBlogCount };
}

async function fetchTotalBlogCount({
  listTypeKey,
  listTypeValue,
  language = 'en',
}: QueryType) {
  let countUrl = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/blogs/count?${listTypeKey}.slug=${listTypeValue}&_locale=${language}`;
  const { data }: AxiosResponse<number> = await API.get(countUrl);
  return { totalBlogs: data };
}

async function fetchPostDetails(
  postSlug: string,
  language = 'en',
): Promise<BlogPostType | null> {
  let url = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/blogs/fetch?Slug=${postSlug}&_locale=${language}`;
  const { data }: AxiosResponse<BlogPostResponseType[]> = await API.get(url);

  if (data[0]) {
    return createPostsfromRawPosts(data[0]);
  }

  return null;
}

async function fetchSuggestedPosts(query: QueryType) {
  let url = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/blogs/fetchmany?`;

  // trending=true&Slug_ne=${query.listTypeToSkip}&_limit=3&
  const queryData: Record<string, any> = {
    trending: true,
    _limit: 3,
    Slug_ne: query.listTypeToSkip,
    _locale: query.language || 'en',
  };

  if (query) {
    queryData[`${query.listTypeKey}.slug`] = query.listTypeValue;
  }
  url += qs.stringify(queryData, { encode: false });

  const { data }: AxiosResponse<BlogPostResponseType[]> = await API.get(url);
  return data.map(post => createPostsfromRawPosts(post));
}

export {
  fetchBlogList,
  fetchPostDetails,
  fetchSuggestedPosts,
  fetchTotalBlogCount,
};
